export const _benefitCardUISchema = {
  validity: {
    'ui:description':
      'Vaatii backend-päivityksen ennen kuin vaikuttaa. Kun asetettu, korvaa Voimassaolon viimeisen päivän.',
  },
  validuntil: {
    'ui:description': 'Käytössä kun voimassaoloaikaa ei ole valittu.',
  },
  createcode: {
    'ui:description': 'Huom! Ominaisuus tuettuna vain Digioven kulunvalvonnan kanssa.',
  },
  accessstart: {
    'ui:description': 'Esimerkiksi 6:30',
  },
  accessend: {
    'ui:description': 'Esimerkiksi 22:00',
  },
  accesslevels: {
    'ui:description': 'Katso mahdolliset arvot Digiovesta. Erottimena pilkku.',
  },
  description: {
    'ui:widget': 'editorWidget',
  },
  confirmationMessage: {
    'ui:widget': 'editorWidget',
  },
  image: {
    'ui:widget': 'imageWidget',
  },
  vat: {
    'ui:enumDisabled': [10, 14, 24],
  },
}

// Aktiviteetin sarjakortti
export const _benefitCardClass = {
  name: { type: 'string', title: 'Sarjakortin nimi' },
  price: { type: 'number', title: 'Hinta, käytä hintavaihtoehtoja', readOnly: true },
  // count: { type: 'number', title: 'Käyntikertojen määrä' },
  // duration: { type: 'number', title: 'Kesto (päivää)' },
  description: { type: 'string', title: 'Kuvaus' },
  validuntil: { type: 'string', format: 'date', title: 'Voimassaolon viimeinen päivä' },
  // Same field names and values as the reservation benefit cards and memberships, so one
  // backend code path can serve all three. When set this wins over validuntil above.
  validity: {
    type: 'string',
    title: 'Voimassaoloaika',
    // The empty option MUST stay first. rjsf takes the first oneOf const as the value when
    // the card has none stored, so without it merely opening and saving an existing card
    // would set 'rolling' and change how that card expires. A plain `default: ''` does not
    // work - the first oneOf const still wins. Empty leaves validuntil in charge.
    oneOf: [
      { const: '', title: 'Ei käytössä (voimassaolon viimeinen päivä ratkaisee)' },
      { const: 'rolling', title: 'Rullaava ajanjakso' },
      { const: 'next', title: 'Seuraavaan ajanjaksoon' },
      { const: 'fixed', title: 'Kiinteä ajanjakso' },
      { const: 'permanent', title: 'Pysyvä' },
    ],
  },
  availableinshop: {
    type: 'string',
    title: 'Näytetäänkö verkkokaupassa',
    oneOf: [
      { const: 'true', title: 'Kyllä' },
      { const: 'false', title: 'Ei' },
    ],
    default: 'false',
  },
  sport: {
    type: 'string',
    title: 'Laji',
    oneOf: [],
  },
  type: {
    type: 'string',
    title: 'Sarjakortin tyyppi',
    oneOf: [
      { const: 'time', title: 'Aikapohjainen' },
      { const: 'count', title: 'Kertapohjainen' },
    ],
  },
  vat: {
    type: 'number',
    title: 'ALV',
    oneOf: [
      { const: 0, title: '0%' },
      { const: 10, title: '10%' },
      { const: 13.5, title: '13,5%' },
      { const: 14, title: '14%' },
      { const: 24, title: '24%' },
      { const: 25.5, title: '25,5%' },
    ]
  },
  variations: {
    title: '',
    description: 'Hintavaihtoehdot',
    type: 'array',
    items: {
      type: 'object',
      properties: {
        name: { type: 'string', title: 'Nimi' },
        price: { type: 'number', title: 'Hinta' },
        productCode: { type: 'string', title: 'Tuotekoodi' },
      },
    },
  },

}
export const _benefitCardClassDeps = {
  type: {
    oneOf: [
      {
        properties: {
          type: {
            enum: ['time'],
          },
          duration: {
            type: 'number',
            title: 'Kesto (päivää)',
          },
          createcode: {
            type: 'string',
            title: 'Luodaanko kortille pääsykoodi? (tukee Digiovea)',
            oneOf: [
              { const: 'true', title: 'Kyllä. Huom! Tukee Digiovea!' },
              { const: 'false', title: 'Ei' },
            ],
          },
        },
        required: ['duration', 'createcode'],
      },
      {
        properties: {
          type: {
            enum: ['count'],
          },
          count: {
            type: 'number',
            title: 'Käyntikertojen määrä',
          },
        },
        required: ['count'],
      },
    ],
  },
  availableinshop: {
    oneOf: [
      {
        properties: {
          availableinshop: {
            enum: ['true'],
          },
          image: { type: 'string', title: 'Verkkokaupan tuotekuva', items: { type: 'object', images: [] }, minaspectratio: 1 },
          confirmationSubject: { type: 'string', title: 'Vahvistusviestin otsikko' },
          confirmationMessage: { type: 'string', title: 'Vahvistusviestin sisältö' },
          accounting: { type: 'string', title: 'Kirjanpidontili' },
        }
      },
      {
        properties: {
          availableinshop: {
            enum: ['false'],
          },
        }
      }
    ]
  },

  // Mirrors the reservation benefit cards (reservationbenefitcard.js) branch for branch.
  validity: {
    oneOf: [
      {
        properties: {
          validity: {
            enum: ['rolling'],
          },
          unit: {
            type: 'string',
            title: 'Rullaava ajanjakso',
            oneOf: [
              { const: 'day', title: 'Päivä' },
              { const: 'week', title: 'Viikko' },
              { const: 'month', title: 'Kuukausi' },
              { const: 'year', title: 'Vuosi' },
            ],
          },
          amount: {
            type: 'number',
            title: 'Montako ajanjaksoa ostohetkestä',
          },
        },
      },
      {
        properties: {
          validity: {
            enum: ['next'],
          },
          endof: {
            type: 'string',
            title: 'Päättyy',
            oneOf: [
              { const: 'month', title: 'Kuukauden lopussa' },
              { const: 'year', title: 'Vuoden lopussa' },
            ],
          },
          daysahead: {
            type: 'number',
            title: 'Montako päivää ennen aletaan myydä seuraavaa ajanjaksoa. 0 = tästä hetkestä kuluvan ajanjakson loppuun asti.',
          },
        },
      },
      {
        properties: {
          validity: {
            enum: ['fixed'],
          },
          firstvalid: {
            type: 'string',
            title: 'Ensimmäinen voimassaolopäivä',
            format: 'date',
          },
          lastvalid: {
            type: 'string',
            title: 'Viimeinen voimassaolopäivä',
            format: 'date',
          },
        },
      },
      {
        properties: {
          validity: {
            enum: ['permanent'],
          },
          firstvalid: {
            type: 'string',
            title: 'Ensimmäinen voimassaolopäivä',
            format: 'date',
          },
        },
      },
    ],
  },

  createcode: {
    oneOf: [
      {
        properties: {
          createcode: {
            enum: ['true'],
          },
          accesslevels: {
            type: 'string',
            title: 'Kortin pääsykoodin kulkutasot.',
          },
        },
        required: ['accesslevels'],
      },
      {
        properties: {
          createcode: {
            enum: ['false'],
          },
        },
      },
    ],
  },
}
